import { Injectable } from '@angular/core';
import { Group } from '../../../models/group.model';
import { GroupContext } from '../../../models/group-context.model';
import { User } from '../../../models/user.model';
import { ViewGroupIdentityContext } from './view-group.types';

@Injectable()
export class ViewGroupIdentityState implements ViewGroupIdentityContext {
	group: Group;
	groupContext: GroupContext = null;
	user: User;
	isAdmin = false;
	isHead = false;
	isHeadOfGroup = false;
	isDeputy = false;

	get hasCurrentGroupContext(): boolean {
		return !!this.group && !!this.group.id && !!this.groupContext &&
			this.group.id === this.groupContext.groupId;
	}

	replace(context: ViewGroupIdentityContext): void {
		this.group = context.group;
		this.groupContext = context.groupContext || null;
		this.user = context.user;
		this.isAdmin = context.isAdmin;
		this.isHead = context.isHead;
		this.isHeadOfGroup = context.isHeadOfGroup;
		this.isDeputy = context.isDeputy;
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-identity.state.ts